module.exports = __webpack_public_path__ + "img/archived-history.b74aadea.svg";